import React from 'react';
import { Button } from '../ui/Button';
export function Solution() {
  return <section className="py-16 px-4 bg-blue-50" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <div className="text-center mb-12" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-135">
            Dormir con un bebé no debería sentirse así
          </h2>
          <div className="bg-white p-6 rounded-xl shadow-md inline-block" data-id="element-136">
            <h3 className="text-xl font-bold text-blue-600 uppercase tracking-wider mb-2" data-id="element-137">
              El problema que nadie dice en voz alta
            </h3>
            <p className="text-2xl md:text-3xl font-extrabold text-gray-900" data-id="element-138">
              👉 Tu bebé no duerme mal. Tu bebé duerme como un bebé.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-139">
          <div className="bg-white p-8 rounded-xl shadow-sm h-full" data-id="element-140">
            <h4 className="font-bold text-lg mb-4 text-gray-900" data-id="element-141">Los bebés:</h4>
            <ul className="space-y-4" data-id="element-142">
              {['Tienen ciclos de sueño más cortos', 'Despiertan naturalmente entre fases', 'Necesitan regulación, no abandono', 'Aprenden a dormir acompañados'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-143">
                  <span className="bg-blue-100 text-blue-600 p-1 rounded-full" data-id="element-144">
                    🌙
                  </span>
                  <span className="font-medium" data-id="element-145">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="space-y-4" data-id="element-146">
            <p className="text-lg text-gray-700" data-id="element-147">
              Hasta el 70% de los bebés menores de 1 año se despiertan varias
              veces por noche. Eso no es un problema.{' '}
              <span className="font-bold" data-id="element-148">Es biología.</span>
            </p>
            <div className="bg-red-100 p-4 rounded-lg text-red-800 font-bold text-center" data-id="element-149">
              ❌ El problema no es tu bebé <br data-id="element-150" />❌ El problema no sos vos
            </div>
            <p className="text-xl font-bold text-center text-gray-900" data-id="element-151">
              El problema es que nadie nos enseñó cómo acompañar el sueño desde
              el amor.
            </p>
          </div>
        </div>

        {/* The Solution Reveal */}
        <div className="bg-white border-4 border-blue-500 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-152">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-400 to-purple-500" data-id="element-153"></div>

          <h2 className="text-green-600 font-black text-3xl md:text-5xl mb-4" data-id="element-154">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-2xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-155">
            MegaPack Dormir Mejor Desde el Amor
          </h3>

          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-156">
            Un sistema completo, respetuoso y basado en ciencia real, diseñado
            para acompañarte paso a paso a mejorar el descanso de tu bebé sin
            dejarlo llorar y sin romper el vínculo.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8 text-sm font-bold text-gray-800" data-id="element-157">
            <div className="bg-gray-50 p-3 rounded-lg border" data-id="element-158">
              📂 Abrís el material
            </div>
            <div className="bg-gray-50 p-3 rounded-lg border" data-id="element-159">
              👀 Entendés lo que le pasa
            </div>
            <div className="bg-gray-50 p-3 rounded-lg border" data-id="element-160">
              💛 Acompañás con seguridad
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-gray-500 font-medium mb-8" data-id="element-161">
            <span data-id="element-162">Sin improvisar.</span> •<span data-id="element-163">Sin métodos agresivos.</span> •
            <span data-id="element-164">Sin culpa.</span>
          </div>

          <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="lg" className="w-full md:w-auto" data-id="element-165">
            👉 QUIERO LA SOLUCIÓN AHORA
          </Button>
        </div>
      </div>
    </section>;
}